import React from "react";
import { Clapperboard, Film, Users, Star, TrendingUp } from "lucide-react";

const DirectorKpiGrid = ({ dashboardData }) => {
  const kpis = [
    {
      title: "Total Projects",
      value: dashboardData?.kpis?.totalProjects || 0,
      icon: <Clapperboard size={18} />,
      trend: "+1 this month"
    },
    {
      title: "Active Roles",
      value: dashboardData?.kpis?.activeRoles || 0,
      icon: <Film size={18} />,
      trend: "Active"
    },
    {
      title: "Total Applicants",
      value: dashboardData?.kpis?.totalApplicants || 0,
      icon: <Users size={18} />,
      trend: "+20%"
    },
    {
      title: "Shortlisted",
      value: dashboardData?.kpis?.shortlisted || 0,
      icon: <Star size={18} />,
      trend: "Selected"
    }
  ];

  return (
    <div className="dd-kpi-grid">
      {kpis.map((kpi, index) => (
        <div className="dd-card dd-kpi-card" key={index}>
          <div className="dd-kpi-top">
            <div className="dd-kpi-icon">{kpi.icon}</div>
            <div className="dd-kpi-trend">
              <TrendingUp size={12} /> <span>{kpi.trend}</span>
            </div>
          </div>
          <h3 className="dd-kpi-value">{kpi.value}</h3>
          <p className="dd-kpi-label">{kpi.title}</p>
        </div>
      ))}
    </div>
  );
};

export default DirectorKpiGrid;
